import React from "react";
import HeaderNavLinks from "./HeaderNavLinks";
import { Navbar, Container, Nav } from "react-bootstrap";
// import CollapsibleExample from "./CollapsibleExample";

const HeaderNavBar = () => {
    // console.log('HeaderNavBar')

    return(
        <>
            <Navbar collapseOnSelect expand="md">
              <Container style = {{backgroundColor: "rgba(255,255,255,.5"}}>
                  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                  <Navbar.Collapse id="responsive-navbar-nav">
                      <Nav>
                          <HeaderNavLinks/>
                      </Nav>
                  </Navbar.Collapse>
              </Container>
            </Navbar>
        </>
    )
};

export default HeaderNavBar;